import { Spread } from "../types/spread";

const weekdaySlots = [
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
];

export const spreads: Spread[] = [
  {
    title: "Класическа Любовна подредба",
    price: 50,
    features: [
      "Яснота за мислите и чувствата на партньора",
      "Разберете дали връзката има бъдеще или върви към край",
      "Съвети от оракулите за бъдещи действия",
      "Въпроси за нови връзки или съмнения в настоящата",
    ],
    href: "klasicheska-lyubovna-podredba",
    orderDescription:
      "Разбери какво изпитва партньорът и накъде води връзката ви в близко бъдеще.",
    inquiryPlaceholder:
      "Необходими са Вашето име, името и датата на раждане на партньора, както и до 10 въпроса.",
    priceId: "price_1TOhXcF0CL1IloXkjZiSrtPF",
    isExpressEligible: true,
    button: {
      text: "Поръчай",
      href: "order/klasicheska-lyubovna-podredba",
    },
    exampleQuestions: [
      "Какво чувства партньорът ми към мен в момента?",
      "Има ли бъдеще нашата връзка?",
      "Защо се отдалечихме един от друг?",
      "Ще се съберем ли отново?",
      "Как мога да подобря връзката си с партньора?",
      "Верен ли ми е партньорът?",
      "Какво пречи на връзката ни да се развие?",
      "Готов ли е партньорът ми за сериозна връзка?",
      "Какво е бъдещето на връзката ни през следващите месеци?",
      "Как партньорът ми възприема нашето бъдеще заедно?",
      "Какво трябва да знам за чувствата на партньора си точно сега?",
      "Има ли шанс за помирение между нас?",
      "Какво влияе на решенията на партньора ми в момента?",
      "Как да преодолеем настоящата криза във връзката?",
      "Мисли ли партньорът ми за раздяла?",
    ],
  },
  {
    title: "Житейски път",
    price: 60,
    features: [
      "Насока към твоето призвание и път на душата",
      "Открива вътрешни блокажи, страхове и самосаботажи, които ви спират",
      "Яснота за професионално и финансово развитие",
      "За хора в период на преосмисляне, промяна или застой",
    ],
    href: "zhiteyski-pat",
    orderDescription:
      "Открий своето призвание и какво те спира по пътя към успеха.",
    inquiryPlaceholder:
      "Необходими са Вашето име, дата на раждане и до 20 въпроса.",
    priceId: "price_1TOhWOF0CL1IloXk36ZM2Z6L",
    isExpressEligible: true,
    button: {
      text: "Поръчай",
      href: "order/zhiteyski-pat",
    },
    exampleQuestions: [
      "Какво е моето истинско призвание?",
      "Какво ме спира да постигна целите си?",
      "Кога ще настъпи промяна в кариерата ми?",
      "Какви са скритите ми страхове и как да ги преодолея?",
      "Накъде ме води моят житейски път през следващите месеци?",
      "Какви уроци трябва да науча в този период от живота си?",
      "Как да открия баланс между работа и личен живот?",
      "Какво ме задържа в моята зона на комфорт?",
      "Кой е следващият важен етап в развитието ми?",
      "Как да преодолея финансовите си притеснения?",
      "Какво трябва да променя, за да постигна успех?",
      "Какви възможности не забелязвам в момента?",
      "Как да намеря смисъл в работата, която върша?",
      "Готов ли съм за нов старт в живота си?",
      "Какво ме саботира несъзнателно?",
      "Как мога да развия увереността си?",
      "Какви решения трябва да взема през следващите месеци?",
      "Кои хора влияят положително на моя път?",
      "Кои хора ми пречат да напредна?",
      "Какво трябва да пусна, за да продължа напред?",
      "Как да се справя с настоящия застой?",
      "Каква е следващата стъпка към моето призвание?",
      "Какво ми носи истинско удовлетворение?",
      "Как да разгърна пълния си потенциал?",
      "Какви промени ме очакват в близко бъдеще?",
    ],
  },
  {
    title: "Годишна Любовна подредба",
    price: 60,
    features: [
      "Поглед за година напред в любовен план",
      "Разкрива влияния от външни фактори или хора, които може да влияят на връзката",
      "Подготовка за ключови периоди и промени през годината",
      "Отлична за хора, които искат дългосрочна визия и насоки в любовта",
    ],
    href: "godishna-lyubovna-podredba",
    orderDescription:
      "Виж как ще се развият любовните ти отношения през цялата година.",
    inquiryPlaceholder:
      "Необходими са Вашето име, името и датата на раждане на партньора, както и до 20 въпроса.",
    highlight: "Най-поръчвана",
    priceId: "price_1TOhVcF0CL1IloXkPUubzVjx",
    isExpressEligible: true,
    button: {
      text: "Поръчай",
      href: "order/godishna-lyubovna-podredba",
    },
    exampleQuestions: [
      "Какво ме очаква в любовта през следващата година?",
      "Кои месеци ще бъдат най-благоприятни за връзката ми?",
      "Ще срещна ли нова любов през годината?",
      "Какви предизвикателства ще срещне връзката ми?",
      "Как да подготвя себе си за важните промени през годината?",
      "Кои влияния отвън могат да засегнат връзката ми?",
      "Ще се задълбочи ли връзката ми през тази година?",
      "Какви уроци ще науча в любовта през следващите месеци?",
      "Кога е най-подходящият момент за важна стъпка във връзката?",
      "Как ще се развият чувствата на партньора ми през годината?",
      "Какви периоди на несигурност да очаквам в любовта?",
      "Ще има ли предложение за брак или сериозен ангажимент?",
      "Как да запазя връзката си стабилна през годината?",
      "Какво трябва да променя в подхода си към любовта?",
      "Ще се появят ли изкушения или трети лица във връзката?",
      "Кои сезони носят най-силна енергия за любовта ми?",
      "Как ще се отрази работата ми на връзката през годината?",
      "Готова/готов ли съм за дългосрочен ангажимент?",
      "Какво ме очаква, ако остана сама/сам през годината?",
      "Как да разпозная правилния момент за нова връзка?",
      "Кои са ключовите точки за обрат в любовния ми живот?",
      "Ще намеря ли емоционална стабилност през годината?",
      "Какво влияе на решенията ми в любовта в момента?",
      "Как да се справя с раздялата, ако такава предстои?",
      "Какво ще донесе следващият сезон за връзката ми?",
    ],
  },
  {
    title: 'Комбо „Житейски път + Любовна подредба"',
    price: 110,
    features: [
      "Комбинира душевна и емоционална перспектива – за цялостен поглед върху живота",
      "Помага да откриете повтарящи се уроци в любовта и житейските теми",
      "Включва специален прочит за избран месец + съвет от оракулите",
      "Подходяща при емоционални и екзистенциални кризи",
    ],
    href: "kombo-paket",
    orderDescription:
      "Дълбок прочит за уроците ти в любовта и житейския път, които да следваш с увереност.",
    inquiryPlaceholder:
      "Необходими са Вашето име, името и датата на раждане на партньора, както и до 30 въпроса.",
    priceId: "price_1TOhUeF0CL1IloXkyFNxm81t",
    isExpressEligible: true,
    button: {
      text: "Поръчай",
      href: "order/kombo-paket",
    },
    exampleQuestions: [
      "Какви уроци в любовта трябва да науча?",
      "Какъв е моят житейски път и как се преплита с любовта?",
      "Кои са повтарящите се теми в живота и връзките ми?",
      "Какво ме очаква през избрания месец?",
      "Какъв съвет имат оракулите за мен в момента?",
      "Как любовният ми живот влияе на професионалното ми развитие?",
      "Какво ме спира да постигна щастие едновременно в любовта и кариерата?",
      "Какви вътрешни блокажи пречат на цялостното ми развитие?",
      "Как да съчетая личните и професионалните си цели?",
      "Какво трябва да пусна, за да напредна и в двете сфери?",
      "Какви са скритите ми страхове във връзка и в работата?",
      "Кой е следващият важен етап в моя път — личен и професионален?",
      "Как да намеря баланс между сърце и разум?",
      "Какви решения ме очакват през следващите месеци?",
      "Как миналото ми влияе на настоящите ми връзки?",
      "Какво трябва да науча за себе си, преди да продължа напред?",
      "Как да разпозная кога дадена връзка или път вече не служи на развитието ми?",
      "Какво ме очаква, ако остана на сегашния си път?",
      "Какви промени биха ми донесли най-голямо щастие?",
      "Как да изградя увереност в личните и професионалните си решения?",
      "Кои хора влияят положително на моя цялостен път?",
      "Кои взаимоотношения трябва да преосмисля?",
      "Какво означава истински успех за мен в момента?",
      "Как да преодолея настоящия застой в живота и любовта?",
      "Какви са посланията на оракулите за моето бъдеще?",
      "Готов/а ли съм за нов старт — лично и професионално?",
      "Как да разгърна пълния си потенциал в любовта?",
      "Как да разгърна пълния си потенциал в кариерата?",
      "Какво трябва да знам за избрания от мен месец напред?",
      "Кои са ключовите уроци, които трябва да усвоя сега?",
      "Как да намеря смисъл едновременно в работата и връзката си?",
      "Какво ме очаква, ако направя решителна промяна сега?",
    ],
  },
  {
    title: "Хорарен въпрос",
    price: 8,
    features: [
      "Ясен и конкретен отговор",
      "Работи с енергията на момента",
      "Подходящ за бързи решения",
      "Намалява съмненията и колебанието",
    ],
    href: "horaren-vapros",
    highlight: "Ново!",
    orderDescription:
      "Отговор на важен за Вас въпрос - дава бърз, фокусиран и директен отговор, без излишни отклонения и общи тълкувания.",
    inquiryPlaceholder:
      "Необходими са само Вашето име и датата Ви на раждане и въпрос",
    priceId: "price_1SgreRF0CL1IloXkiLXdWGD4",
    button: {
      text: "Поръчай",
      href: "order/horaren-vapros",
    },
    receiveByDays: "1 ден",
  },
  {
    title: "Таро Терапия",
    price: 111,
    features: [],
    href: "taro-terapia",
    orderDescription: `
90 минути разговор, в които да разбереш себе си, както и да зададеш въпросите, които са важни за теб и твоят път в бъдеще.`,
    inquiryPlaceholder: "Необходими са Вашето име и датата Ви на раждане.",
    priceId: "price_1TiCeZF0CL1IloXkVucVf0H9",
    button: {
      text: "Поръчай",
      href: "order/taro-terapia",
    },
    fullWidthBanner: true,
    durationLabel: "90 мин",
    bookingSchedule: [
      { dayOfWeek: 6, slots: ["11:00", "12:30", "14:00", "15:30", "17:00"] },
      { dayOfWeek: 0, slots: ["11:00", "12:30", "14:00", "15:30", "17:00"] },
    ],
  },
  {
    title: "Видео разговор",
    price: 60,
    features: [],
    href: "taro-terapia-30",
    orderDescription: `
 30 минутен видеоразговор за едно житейско направление с до 10 предварително подготвени, различни въпроса.`,
    inquiryPlaceholder: "Необходими са Вашето име и датата Ви на раждане.",
    priceId: "price_1UDU76F0CL1IloXkfuhEz5Oj",
    button: {
      text: "Поръчай",
      href: "order/taro-terapia-30",
    },
    fullWidthBanner: true,
    durationLabel: "30 мин",
    bookingSchedule: [
      { dayOfWeek: 1, slots: weekdaySlots },
      { dayOfWeek: 2, slots: weekdaySlots },
      { dayOfWeek: 3, slots: weekdaySlots },
      { dayOfWeek: 4, slots: weekdaySlots },
      { dayOfWeek: 5, slots: weekdaySlots },
      { dayOfWeek: 6, slots: ["10:00", "10:30", "17:30"] },
    ],
  },
  {
    title: "Месечна таро прогноза",
    price: 30,
    features: [
      "Енергията на месеца и основните тенденции",
      "Предизвикателства и възможности, които ще се проявят",
      "Развитие в професионален, финансов и любовен план",
      "Насоки за благоприятните енергии и за избягване на пречки",
    ],
    href: "mesechna-taro-prognoza",
    orderDescription:
      "Твоят път през месеца към достигане на увереност, щастие и любов.",
    inquiryPlaceholder: "Необходими са само Вашето име и датата Ви на раждане",
    priceId: "price_1TOhRcF0CL1IloXk9chgtFpS",
    isExpressEligible: true,
    button: {
      text: "Поръчай",
      href: "order/mesechna-taro-prognoza",
    },
  },
];
